<template>
	<div class="weightRadioGroup">
		<label v-for="option in options" :key="option.value" :class="{ active: option.value === value }">
			<input class="controlRadio-input" type="radio" :value="option.value" :checked="option.value === value" @change="$emit('input', option.value)">
			<span class="controlRadio-state"></span>
			<a class="weightRadioGroup-infoIcon" v-if="option.hasInfoModal"
			data-fancybox href="#modal-weight-info" @click="infoClick(option)"><img src="@/assets/icons/info.svg" class="weightRadioGroup-infoIcon-img"></a>
			<div class="weightRadioGroup-title">Серия {{ option.serieName }}</div>
			<div class="weightRadioGroup-text">
				Нагрузка<br/>
				{{ option.text }}
			</div>
			<div class="weightRadioGroup-picture">
				<img v-if="option.img"
					:src="option.img" />
			</div>
		</label>
	</div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
	props: {
		options: {
			type: Array,
			default: [],
		},
		value: {},
	},
	inject: {
		setWeightInfoData: 'setWeightInfoData'
	},
	methods: {
		infoClick(option) {
			this.setWeightInfoData(option)
		}
	}
})
</script>
